import { useState, useEffect, useRef } from 'react';
import {
  getAccent, saveAccent, resetAccent, themeDefaultAccent, ACCENT_PRESETS,
} from '../../utils/theme';

// Compact accent-colour picker (works in both light & dark themes). The trigger
// sits next to the theme toggle; clicking opens a popover with presets + custom.
export function AccentPicker() {
  const [open, setOpen]   = useState(false);
  const [custom, setCustom] = useState(getAccent()); // chosen colour, or null
  const ref = useRef(null);
  const effective = custom || themeDefaultAccent();

  useEffect(() => {
    if (!open) return;
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', onDoc);
    document.addEventListener('keydown', onKey);
    return () => { document.removeEventListener('mousedown', onDoc); document.removeEventListener('keydown', onKey); };
  }, [open]);

  const pick  = (c) => { setCustom(c); saveAccent(c); };
  const reset = () => { setCustom(null); resetAccent(); };

  const isSel = (c) => !!custom && c.toLowerCase() === custom.toLowerCase();

  return (
    <div className="accent-ctl" ref={ref}>
      <button
        className="accent-trigger"
        onClick={() => setOpen(o => !o)}
        title="Accent colour"
        aria-label="Accent colour"
      />
      {open && (
        <div className="accent-pop" role="dialog" aria-label="Accent colour">
          <div className="accent-pop__title">Accent</div>
          <div className="accent-pop__presets">
            {ACCENT_PRESETS.map(c => (
              <button
                key={c}
                className={`accent-pop__preset${isSel(c) ? ' accent-pop__preset--sel' : ''}`}
                style={{ background: c }}
                onClick={() => pick(c)}
                aria-label={`Accent ${c}`}
              />
            ))}
          </div>
          <div className="accent-pop__row">
            <span className="accent-pop__label">Custom</span>
            <input
              className="accent-pop__swatch"
              type="color"
              value={effective}
              onChange={(e) => pick(e.target.value)}
              aria-label="Custom accent colour"
            />
          </div>
          <button className="accent-pop__reset" onClick={reset}>Reset to default</button>
        </div>
      )}
    </div>
  );
}
